import type { NavLink } from '@/types'

export const MAIN_NAV: NavLink[] = [
    { label: 'Rice varieties', href: '/products' },
    { label: 'Quality', href: '/#quality' },
    { label: 'About us', href: '/about' },
    { label: 'FAQ', href: '/#faq' }
]

export const FOOTER_EXPLORE: NavLink[] = [
    { label: 'Rice varieties', href: '/products' },
    { label: 'Quality control', href: '/#quality' },
    { label: 'How we work', href: '/#process' },
    { label: 'Packing and logistics', href: '/#packaging' },
    { label: 'About us', href: '/about' },
    { label: 'FAQ', href: '/#faq' }
]
